/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Experiment_AutomaticInputs */

const en_pricing_experiment_automatic = /** @type {(inputs: Pricing_Experiment_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic (A/B assignment)`)
};

const es_pricing_experiment_automatic = /** @type {(inputs: Pricing_Experiment_AutomaticInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automático (asignación A/B)`)
};

/**
* | output |
* | --- |
* | "Automatic (A/B assignment)" |
*
* @param {Pricing_Experiment_AutomaticInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_experiment_automatic = /** @type {((inputs?: Pricing_Experiment_AutomaticInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Experiment_AutomaticInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_experiment_automatic(inputs)
	return en_pricing_experiment_automatic(inputs)
});